// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { AuthorizationConfig, GeneralEnvironmentInfo } from '../app/services/authorization_config';

export const environment: AuthorizationConfig & GeneralEnvironmentInfo =
{
    production:  !0,
    isExternal: "Y",
    imgdynamicurl: "../../mw",
    //apiBaseUrl: 'http://localhost:59095',
    //apiBaseUrl: 'https://qa.apps.dewa.gov.ae/iam/iamapi/api/iamoneid',
    //apiBaseUrl: 'http://localhost:49891/api/proxy', //api/iamoneid
    apiBaseUrl: 'https://smartloginuat.dewa.gov.ae/mw/mwAPI/api/proxy', //api/iamoneid
    //fileBaseUrl: 'http://localhost:49891',
    fileBaseUrl: 'https://smartloginuat.dewa.gov.ae',
    // issuer_uri: 'https://accounts.google.com',
    // client_id: '465844544800-f1k5bhu8jibs9vc1ifh7nmhpmh7nqnod.apps.googleusercontent.com',
    // redirect_uri: 'http://localhost:4200/callback',
    issuer_uri: 'https://smartloginuat.dewa.gov.ae',
    redirect_uri: 'https://smartloginuat.dewa.gov.ae/mw/callback.html',
    //client_id: 'IAM_Middleware',
    client_id: 'IAM_MiddlewareQA',
    client_secret: 'middleware@123',
    extras: {
       
    },
    thakool: '',
    testEmail:'tayyab.islam@dewa.gov.ae'
};